/**
 * 账号模块 - 基础请求文件
 * 取名zz，仅是为了排序
 */
import baseRequest from '@/utils/request'
import { serverName } from '../../config'

function request(option) {
  option.url = serverName.platform.account + option.url
  return baseRequest(option)
}

export default request



// WEBPACK FOOTER //
// ./src/api/platform/account/zz.js